module.exports = __webpack_public_path__ + "static/img/banner-pc.dc29f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner-pc.jpg
// module id = UdWz
// module chunks = 1